import { Transition } from "@headlessui/react";
import { APP_VERSION } from "helpers/constants";
import useTheme from "hooks/useTheme";
import React, { Fragment } from "react";
import BugIcon from "theme/icons/Bug";
import TelegramIcon from "theme/icons/Telegram";
import TwitterIcon from "theme/icons/Twitter";

const FollowUsLandingPage = () => {
	const { appLanguage, themeColor } = useTheme();

	return (
		<Transition
			as={Fragment}
			appear={true}
			show={true}
			enter="transition-opacity duration-500"
			enterFrom="opacity-0"
			enterTo="opacity-100"
		>
			<div className="w-[50%] h-full flex flex-col justify-between py-10">
				<div className="flex flex-col w-full items-center justify-center space-y-3">
					<p className={`text-lg font-bold ${themeColor?.text}`}>{appLanguage?.followUs}</p>

					<div className="flex w-full items-center justify-center space-x-7">
						<TwitterIcon
							className={`w-12 cursor-pointer`}
							fill={themeColor?.hex}
							onClick={() => window.open("https://twitter.com/daffiwallet", "_blank")}
						/>
						<TelegramIcon
							className={`w-12 cursor-pointer`}
							fill={themeColor?.hex}
							onClick={() => window.open("https://t.me/+3hXsrzmB295hMjg0", "_blank")}
						/>
					</div>
				</div>

				<div className="flex flex-col w-full items-center justify-center space-y-2">
					<div className="flex flex-col w-full items-center justify-center">
						<p
							className={`text-lg text-center font-bold ${themeColor?.text}`}
							dangerouslySetInnerHTML={{ __html: appLanguage?.forBugsCommentsSuggestions }}
						/>
					</div>

					<BugIcon
						className={`w-12 cursor-pointer`}
						fill={themeColor?.hex}
						onClick={() =>
							window.open(
								`https://forms.zohopublic.com/rdinitiativ/form/DaffiWalletAndroidBugReporting/formperma/PNWlpyq9SYqu9OBAJmqXsVVQ-Xs6OVznVGCecia_pj0`,
								"_blank"
							)
						}
					/>
				</div>

				<div className="flex flex-col w-full items-center justify-center space-y-2">
					<div className="flex flex-col w-full items-center justify-center">
						<p
							className={`text-lg  text-center font-bold ${themeColor?.text}`}
							dangerouslySetInnerHTML={{ __html: appLanguage?.visitOurSites }}
						/>
					</div>

					<div className="flex flex-col w-full items-center justify-center">
						<p
							className={`text-lg text-center font-bold ${themeColor?.text}`}
							dangerouslySetInnerHTML={{ __html: appLanguage?.daffiWebSites }}
						/>
					</div>
				</div>

				<div className="flex flex-col w-full items-center justify-center">
					<p className={`text-sm font-bold ${themeColor?.text}`}>{appLanguage?.version}</p>
					<p className={`text-sm font-bold ${themeColor?.text}`}>
						Daffi
						<span className="italic">Wallet</span> {APP_VERSION}
					</p>
				</div>
			</div>
		</Transition>
	);
};

export default FollowUsLandingPage;
